import type { IAugmentedJQuery } from "angular";
import { module } from "angular";
import $ from "jquery";

import "./alarmVideo.html";
import "./AlarmVideo.scss";

module("mmGui").directive("irAlarmVideo", [
    () => {
        function link($scope: any, element: IAugmentedJQuery) {
            $scope.hasError = false;
            $scope.width = 0;
            $scope.height = 0;

            const video = element[0].querySelector("video");
            const sources = video.querySelectorAll("source");
            $(sources[sources.length - 1]).on("error", () => {
                $scope.hasError = true;
                $scope.onerror();
                $scope.$applyAsync();
            });

            video.addEventListener("loadeddata", () => {
                $scope.width = video.videoWidth;
                $scope.height = video.videoHeight;
                $scope.videoLoaded = true;
                $scope.$applyAsync();
            });
        }

        return {
            link,
            require: "^ngModel",
            restrict: "E",
            scope: {
                onerror: "&",
                video: "=ngModel",
                overlay: "@",
            },
            templateUrl: "/App/Modules/Gui/Components/AlarmVideo/alarmVideo.html",
        };
    },
]);
